/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

function SEOCategoryContent(props) {
  const { content } = props;
  let showcase = null;
  if (content.type === 'TYPE1') {
    const { question, paragraph1 } = content;
    showcase = (
      <div className="mx-0 pt-3">
        <content.questionTag
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph1 }}
        />
      </div>
    );
    return showcase;
  }
  if (content.type === 'TYPE2') {
    const { question, paragraph1, paragraph2 } = content;
    showcase = (
      <div className="mx-0 pt-3">
        <content.questionTag
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph1 }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph2 }}
        />
      </div>
    );
    return showcase;
  }
  if (content.type === 'TYPE3') {
    const {
      question, paragraph1, paragraph2, paragraph3,
    } = content;
    showcase = (
      <div className="mx-0 pt-3">
        <content.questionTag
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph1 }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph2 }}
        />
        <div
          className="mx-0 mt-2 text-secondary"
          dangerouslySetInnerHTML={{ __html: paragraph3 }}
        />
      </div>
    );
    return showcase;
  }
  return '';
}

SEOCategoryContent.propTypes = {
  content: PropTypes.shape({}).isRequired,
};

export default SEOCategoryContent;
